import React, {useEffect, useState} from 'react'
import { Typography, Divider, FloatButton, Row, Col, Skeleton, Progress } from 'antd'
import { RadarChartOutlined, AppstoreOutlined, DeploymentUnitOutlined, ArrowLeftOutlined, BranchesOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import image from "../../../Assets/pokeball.png"
import image2 from "../../../Assets/Pokebola-pokeball-png-0.png"

import { 
    Container, 
    Card, 
    CardActions, 
    PokeImage,
    BallImage, 
    CardActionsButtons, 
    PokeTipo, 
    CardData, 
    PokeTitle, 
    PokeIntro,
    MiniCard,
    MiniContainer,
    MiniPoke,
    MiniBall,
    CardImg
} from "./styles"

const { Title, Paragraph } = Typography;

import { usePokemonDetalle } from '../../../Hooks/Player';
import { FocusCarta } from '../Home/MiEquipo/components/modalDetail';

const POKECARTASURL = import.meta.env.VITE_POKECARTAS_URL;

export const PokeCard = ({id}) => {
    const [showCard, setShowCard] = useState([false, ""]);
    const navigate = useNavigate();

    const { data, isFetching: cargandoData } = usePokemonDetalle(id);

    if (!cargandoData && !data.capturado) navigate("/pokedex")

    const [index, setPage] = useState(0)
    const [disableImage, setDisableImage] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setDisableImage(!disableImage)
        }, 2000);
    }, [id])

    
    const pages = {
        0: "Información",
        1: "Estadísticas",
        2: "Evoluciones",
        3: "Variantes",
    }

    return (
        <>
         {
            cargandoData ? <SkeletonLoading /> : 
            <Container color={data.colorCard}>
                <FloatButton icon={<ArrowLeftOutlined />} style={{ left: 10, top: 10 }} onClick={() => navigate("/pokedex")}/>
                
                <BallImage src={image}/>

                <PokeTitle>
                    <Title style={{ color: "rgb(247, 247, 247)", fontFamily: "POKEFONT" }} level={4} italic>{`#${data.numero_pokedex.toString().padStart(3, "0")}`}</Title>
                    <Title style={{ color: "white", marginTop: "-15px", fontFamily: "POKEFONT" }} level={1}>{data.nombre}</Title>
                    <PokeTipo src={data.imagTipoP} />
                </PokeTitle>

                <Card>
                    <PokeImage src={data.imagPokemon}/>
                    <Title level={5} style={{margin: "7% 0px 0px 20px", fontFamily: "POKEFONT"}}>{pages[index]}</Title>
                    <Divider/>
                    <CardData>
                        {
                            index == 0 && 
                                <Descripcion data={data}/>
                        }
                        {
                            index == 1 && 
                                <Estadisticas data={data} showCard={showCard} setShowCard={setShowCard}/>
                        }
                        {
                            index == 2 &&
                                <Relacionados data={data}/>
                        }
                        {
                            index == 3 &&
                                <Relacionados data={data} variantes={true}/>
                        }
                    </CardData>
                    <CardActions>
                        <Divider />
                        <CardActionsButtons>
                            <AppstoreOutlined onClick={() => setPage(0)} style={{ color: index == 0 && data.colorCard }}/>
                            <RadarChartOutlined onClick={() => setPage(1)} style={{ color: index == 1 && data.colorCard }}/>
                            <DeploymentUnitOutlined onClick={() => setPage(2)} style={{ color: index == 2 && data.colorCard }}/>
                            {
                                Object.keys(data.variantes).length > 0 && 
                                <BranchesOutlined onClick={() => setPage(3)} style={{ color: index == 3 && data.colorCard }}/>
                            }
                        </CardActionsButtons>
                    </CardActions>

                </Card>
                {!disableImage && <PokeIntro src={image2}/>}
            </Container>
         }
         
         {showCard[0] && <FocusCarta setShowCard={setShowCard} showCard={showCard} />}
        </>
       
    )
}

const Descripcion = ({ data }) => {
    return (
        <div style={{marginTop: "1vh"}}>
            <Paragraph italic>{data.descripcion ?? ""}</Paragraph>
            
            <div style={{marginLeft: "7vw", marginTop: "3vh"}}>
                <Row>
                    <Col span={11}>
                    <strong>Seudónimo</strong>
                    </Col>
                    <Col span={13}>
                    {data.seudonimo}
                    </Col>
                </Row>
                <Row>
                    <Col span={11}>
                    <strong>Tipo Principal</strong>
                    </Col>
                    <Col span={13}>
                    {data.tipo_principal.toString().charAt(0).toUpperCase() + data.tipo_principal.toString().slice(1)}
                    </Col>
                </Row>
                {
                    data.tipo_secundario && 
                    <Row>
                        <Col span={11}>
                        <strong>Tipo Secundario</strong>
                        </Col>
                        <Col span={13}>
                        {data.tipo_secundario.toString().charAt(0).toUpperCase() + data.tipo_secundario.toString().slice(1)}
                        </Col>
                    </Row>
                }
                <Row>
                    <Col span={11}>
                    <strong>Altura</strong>
                    </Col>
                    <Col span={13}>
                    {(data.altura.toString().slice(0, -1) != "" ? data.altura.toString().slice(0, -1) : "0") + '.' + data.altura.toString().slice(-1)} m
                    </Col>
                </Row>
                <Row>
                    <Col span={11}>
                    <strong>Peso</strong>
                    </Col>
                    <Col span={13}>
                    {(data.peso.toString().slice(0, -1) != "" ? data.peso.toString().slice(0, -1) : "0") + '.' + data.peso.toString().slice(-1)} kg
                    </Col>
                </Row>
            </div>
        </div>
    )
}

const Estadisticas = ({ data, showCard, setShowCard }) => {
    return (
        <div style={{marginTop: "1vh"}}>
            <Paragraph>Estadísticas Carta</Paragraph>
            <Row style={{ marginTop: '20px', marginBottom: '10px' }}>
                <Col span={7}>
                    <strong>Vida</strong>
                </Col>
                <Col span={17}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Progress percent={(data.vida / 20) * 100} showInfo={false} style={{ flexGrow: 1 }} strokeColor={data.colorCard} />
                        <span style={{ marginLeft: '5px', width: '25px' }}>{data.vida}</span>
                    </div>
                </Col>
            </Row>
            <Row style={{ marginBottom: '10px' }}>
                <Col span={7}>
                    <strong>Ataque</strong>
                </Col>
                <Col span={17}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Progress percent={(data.ataque / 20) * 100} showInfo={false} style={{ flexGrow: 1 }} strokeColor={data.colorCard} />
                        <span style={{ marginLeft: '5px', width: '25px' }}>{data.ataque}</span>
                    </div>
                </Col>
            </Row>
            <Row style={{ marginBottom: '10px' }}>
                <Col span={7}>
                    <strong>Velocidad</strong>
                </Col>
                <Col span={17}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Progress percent={(data.velocidad / 20) * 100} showInfo={false} style={{ flexGrow: 1 }} strokeColor={data.colorCard} />
                        <span style={{ marginLeft: '5px', width: '25px' }}>{data.velocidad}</span>
                    </div>
                </Col>
            </Row>
            
            <div style={{marginTop: "1vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
                <CardImg src={`${POKECARTASURL}${data.idPokemon}.png`} onClick={() => setShowCard([!showCard[0], `${POKECARTASURL}${data.idPokemon}.png`])}/>
            </div>
            
        </div>
    )
}


const Relacionados = ({ data, variantes = false }) => {
    return (
        <>
            {
                variantes ? 
                <div>
                    {
                        Object.keys(data.variantes).length > 0 && 
                        <MiniContainer>
                            {
                                data.variantes.map((item, index) => <PokeMiniCard data={item} key={index}/>)
                            }
                        </MiniContainer>
                    }
                </div> : 
                <div>
                    {
                        Object.keys(data.evoluciones).length > 0 && 
                        <MiniContainer>
                            {
                                data.evoluciones.map((item, index) => <PokeMiniCard data={item} key={index}/>)
                            }
                        </MiniContainer>
                    }
                    {
                        Object.keys(data.prevoluciones).length > 0 && 
                        <>
                            <Title level={5} style={{marginTop: 0}}>Prevoluciones</Title>
                            <MiniContainer>
                                {
                                    data.prevoluciones.map((item, index) => <PokeMiniCard data={item} key={index}/>)
                                }
                            </MiniContainer>
                        </>
                    }
                </div>
            }
        </>
    )
}

const PokeMiniCard = ({ data }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (data.capturado && data.numeroDex) {
            navigate(`/pokedex/detalle?n_pokedex=${data.numeroDex}`);
            window.location.reload();
        }
    }
    return (
        <MiniCard onClick={() => handleClick()}>
            <MiniBall src={image}/>
            <MiniPoke src={data.imagPoke} capturado={data.capturado.toString()}/>
            <Paragraph style={{ marginTop: "-5px", display: "inline-block", whiteSpace: "nowrap" }} strong>{data.capturado ? data.nombre : "???"}</Paragraph>
            <Paragraph style={{ marginTop: "-20px" }} italic>{`#${data.numeroDex ? data.numeroDex.toString().padStart(3, "0") : data.numero_dex.toString().padStart(3, "0")}`}</Paragraph>
        </MiniCard>
    )
}

const SkeletonLoading = () => {
    return (
        <Container color={"white"}>
                <FloatButton icon={<ArrowLeftOutlined />} style={{ left: 10, top: 10 }} onClick={() => navigate("/pokedex")}/>
                
                <BallImage src={image}/>

                <PokeTitle>
                    <Skeleton.Input active={true} style={{ marginTop: "5vh" }} size='small'/>
                    <br />
                    <Skeleton.Input active={true} style={{ marginTop: "10px", width: "50vw" }} size='small'/>
                    <br />
                    <Skeleton.Input active={true} style={{ marginTop: "10px"}} size='small'/>
                </PokeTitle>

                <Card>
                    <Skeleton.Avatar style={{ width: "90vw", borderRadius: "20px 20px 0px 0px", height: "55vh"}} active={true}/>

                </Card>
        </Container>
    )
}
